import sortBy from 'lodash/sortBy';

import { ASSESSMENT, LESSON } from 'global/constants';

export function mergeLessonAssessment<T>(
  lessons: T[],
  assessments: T[],
  isIntegrated: boolean
) {
  return sortBy(
    [
      ...lessons.map(lesson => {
        return {
          ...lesson,
          type: LESSON as typeof LESSON,
        };
      }),
      ...assessments.map(assessment => {
        return {
          ...assessment,
          type: ASSESSMENT as typeof ASSESSMENT,
        };
      }),
    ],
    isIntegrated ? 'integratedSort' : 'sort'
  );
}
